import { useEffect } from 'react'
import { CourseSearch } from '@/components/CourseSearch/CourseSearch'
import { useEventLogger } from '@/hooks/useEventLogger'
import { useAppSelector } from '@/store/hooks'

export const EnrolledCoursesSearch = () => {
  const { logEvent } = useEventLogger()

  const enrolledCoursesSearchText = useAppSelector((state) => state.aggregates.enrolledCoursesSearchText)

  useEffect(() => {
    logEvent('my_courses_search')
  }, [enrolledCoursesSearchText, logEvent])

  return <CourseSearch type="enrolled" />
}
